<script>
import { mapGetters } from 'vuex'
import SubHeader from '@components/sub-header'
import CalificationButton from '@components/calification-button'
import { widgetActions } from '@state/helpers'

export default {
  name: 'Rate',
  components: {
    SubHeader,
    CalificationButton,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('widgets', ['widgetProperty']),
  },
  created() {
    this.componentData.buttons.map(b => (b.isSelected = false))
  },
  methods: {
    ...widgetActions,
    setOption(option) {
      this.componentData.buttons.map(
        b => (b.isSelected = b.value === option.value)
      )
      this.commitWidgetChanges({
        widgetName: 'HelpOptions',
        data: {
          show: option.value <= 3,
        },
      })
      this.commitWidgetChanges({
        widgetName: 'Rate',
        data: {
          value: option.value,
        },
      })
      this.$forceUpdate()
    },
  },
}
</script>

<template>
  <div :class="$style.container">

    <h4>{{ componentData.title }}</h4>

    <div :class="$style.container__buttons">
      <CalificationButton
        v-for="(b, i) in componentData.buttons"
        :key="i"
        :button="b"
        :is-selected="b.isSelected"
        @clickedCalification="setOption"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: 1rem;
  margin: $size-spacing-medium 0;
  background-color: #fff;

  &__buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0.5rem;
  }

  h4 {
    @extend %typography-medium;

    margin-left: 0;
    font-weight: bold;
    color: $darker-gray;
  }
}
</style>
